<template>
  <h1 class="title has-text-centered is-spaced">
    <go-to-dashboard-button />

    {{ $t("totems.totems") }}
    <span v-show="!c1 && !c2">&nbsp;</span>

    <br v-show="c1" />

    <button
      class="button"
      @click="$emit('get-totems')"
      :style="c1 ? 'margin-top: 1rem;' : ''"
    >
      <b-icon icon="sync-alt"></b-icon>
    </button>

    <hr />
  </h1>
</template>

<script>
import { common } from "../../mixins/common";
import { responsive } from "../../mixins/responsive";
import goToDashboardButton from "../common/GoToDashboardButton";
import { mapGetters } from "vuex";

export default {
  props: ["storeId", "storeName"],

  mixins: [common, responsive],

  components: {
    goToDashboardButton
  },

  data() {
    return {};
  },

  computed: {
    ...mapGetters(["permissions"]),

    c1() {
      return this.windowWidth < 700;
    },
    c2() {
      return this.windowWidth < 370;
    }
  }
};
</script>

<style scoped>
.inline {
  display: inline;
}
hr {
  background-color: hsl(0, 0%, 71%);
}
</style>
